export const CACHE_KEY = "stat_loaded"

export const CACHE_VALID_FOR_SECONDS = 86400